// extracted by mini-css-extract-plugin
export default {"defaultIcon":"BYcUlKyoh5FJki_ra6UE__defaultIcon___"};